export default "__VITE_ASSET__DANc3_Op__"